<template>
  <div>
    <div>
      <img src="../../public/images/EEG_LOGO.png" style="max-width: 628px; width:100%"/>
    </div>
    <div class="workArea">
      <div class="style1">
        შეფასებისა და გამოცდების ეროვნული ცენტრის მიერ შემუშავებული და დანერგილი საგამოცდო მოდელი შეფასების სამართლიან
        და
        გამჭვირვალე პრინციპებზე დამყარებული სისტემაა, რომელიც უზრუნველყოფს საუკეთესო აბიტურიენტების შერჩევას უმაღლესი
        სასწავლებლებისათვის.
      </div>
      <div class="placeholder">
        <a :href="regUrl">
          <div class="actionText">
            <img :src="imagePath('UEE_reg_default.png')" height="122" width="122"/></div>
          <div class="actionText">
            სარეგისტრაციო განაცხადში საგანმანათლებლო პროგრამების მითითებისა და
            შეცვლის საშუალება აბიტურიენტებს აპელაციების შედეგების გამოქვეყნებიდან მომდევნო დღის ჩათვლით ექნებათ.
          </div>
        </a>
      </div>
      <div class="placeholder">
        <div class="disabled" v-if="!showResults"></div>
        <a :href="resultsUrl">
          <div class="actionText">
            <img :src="imagePath('UEE_res_defailt.png')" height="122" width="122"/>
          </div>
          <div class="actionText">
            ერთიან ეროვნულ გამოცდებზე მიღებული შედეგების სანახავად გადადით ამ ბმულზე.
          </div>
        </a>
      </div>
      <div class="placeholder ">
        <div class="disabled" v-if="!appealMode"></div>
        <a :href="appealsUrl">
          <div class="actionText">
            <img :src="imagePath('UEE_Appeal.png')" height="122" width="122"/></div>
          <div class="actionText ">
            ერთიანი ეროვნული გამოცდების შედეგების აპელირებისათვის გადადით ამ ბმულზე.
          </div>
        </a>

      </div>


      <br>
    </div>
  </div>

</template>

<script>
import axios from "axios";

export default {
  name: "entrantdefault",
  data: () => ({
    appealMode: 0,
    showResults: 0,
    regUrl: "",
    resultsUrl: "",
    appealsUrl: "",


  }),
  async created() {
    try {
      debugger;
      let ts = +(new Date());
      let response = await axios.get(process.env.BASE_URL + "entrant-cfg.json?ts=" + ts);

      this.appealMode = +response.data.appealMode;
      this.showResults = +response.data.showResults;
      this.regUrl = response.data.regUrl || "https://online.naec.ge/ueereg/entrants/EntrantsLogin.aspx"
      this.resultsUrl = response.data.resultsUrl || "https://online2.naec.ge/uee-res/";
      this.appealsUrl = response.data.appealsUrl || "https://online2.naec.ge/appeals";

    } catch (e) {
      console.log(e);
    }
  }
  ,
  methods: {
    imagePath(imageName) {
      return process.env.BASE_URL + "images/" + imageName
    }
  }
}
</script>

<style scoped>
.workArea {
  background-color: #F2F2F0;
  padding: 15px;
  min-height: 500px;
  -moz-border-radius: 19px;
  border-radius: 19px;
}

.style1 {
  font-family: Sylfaen;
  font-size: small;
  color: #777777;
  position: relative;
  max-width: calc(100% - 220px);
  z-index: 100;
  top: -40px;
  left: 180px;
  padding: 8px;
  border-radius: 10px;
  background-color: #EEEEEE;
  border: 1px solid #CCCCCC;
  margin-bottom: -60px;
}


.placeholder {
  padding: 20px 20px 20px 40px;
  position: relative;

}

.placeholder:disabled {
  cursor: default;
}

.actionText {

  display: inline-block;
  max-width: 500px;
  padding-right: 20px;
  vertical-align: middle;
  font-size: small;
}

.disabled {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  background-color: #F1F1F1;
  opacity: 0.7;
}

.hlink {
  display: inline-block;
  cursor: pointer;
  color: darkblue;
}
</style>